import React from "react";
import PathOption from "../PathOption";
import PathOptionGroup from "../PathOptionGroup";

function PathBuilderOptionsSeedkeeper({ t, options, handleOptionChange, osSelected }) {
  return (
    <PathOptionGroup title={t("pathBuilder.categories.seedsignerSeedkeeper")}>
      <PathOption
        id="backup-seed-to-seedkeeper"
        label={t("pathBuilder.checkboxes.backupSeedToSeedkeeper")}
        checked={options.backupSeedToSeedkeeper}
        onChange={() => handleOptionChange("backupSeedToSeedkeeper")}
        disabled={!osSelected}
      />
      <PathOption
        id="import-key-from-seedkeeper"
        label={t("pathBuilder.checkboxes.importKeyFromSeedkeeper")}
        checked={options.importKeyFromSeedkeeper}
        onChange={() => handleOptionChange("importKeyFromSeedkeeper")}
        disabled={!osSelected}
      />
    </PathOptionGroup>
  );
}

export default PathBuilderOptionsSeedkeeper;
